import React from "react";
import { BsGithub } from "react-icons/bs";
import { FaGlobe } from "react-icons/fa";

const ProjectsCard = ({ title, des, src, github, live, variant }) => {
  const imageLink = live || github;

  const isPowerBI = variant === "powerbi";

  return (
    <div
      className="
        w-full p-4 xl:px-12 xl:py-10 rounded-lg
        shadow-shadowOne
        flex flex-col
        bg-gradient-to-r from-bodyColor to-[#202327]
        border border-designColor/20
        transition-all duration-300 ease-in-out
        hover:-translate-y-1
        hover:border-designColor/60
      "
    >
      {/* Image */}
      {imageLink ? (
        <a href={imageLink} target="_blank" rel="noopener noreferrer">
          <div
            className={`
              w-full overflow-hidden rounded-lg
              ${isPowerBI ? "h-44" : "h-60"}
            `}
          >
            <img
              className={`
                w-full h-full
                ${isPowerBI ? "object-contain" : "object-cover"}
                transition-transform duration-300
                hover:scale-105
              `}
              src={src}
              alt={title}
            />
          </div>
        </a>
      ) : (
        <div
          className={`
            w-full overflow-hidden rounded-lg
            ${isPowerBI ? "h-44" : "h-60"}
          `}
        >
          <img
            className={`
              w-full h-full
              ${isPowerBI ? "object-contain" : "object-cover"}
            `}
            src={src}
            alt={title}
          />
        </div>
      )}

      {/* Content */}
      <div className="w-full mt-5 flex flex-col gap-4">
        <div className="flex items-start justify-between gap-3">
          <h3
            className="
              text-base uppercase text-designColor font-normal
              leading-5
              min-h-[40px]
              max-h-[40px]
              overflow-hidden
              line-clamp-2
            "
          >
            {title}
          </h3>

          {/* Icons */}
          <div className="flex gap-2 shrink-0">
            {/* GitHub ONLY for SQL & Data Eng */}
            {github && !live && (
              <a
                href={github}
                target="_blank"
                rel="noopener noreferrer"
                className="
                  text-lg w-10 h-10 rounded-full bg-black
                  inline-flex justify-center items-center
                  text-gray-400
                  hover:text-designColor transition
                "
              >
                <BsGithub />
              </a>
            )}

            {/* Globe ONLY for Power BI */}
            {live && (
              <a
                href={live}
                target="_blank"
                rel="noopener noreferrer"
                className="
                  text-lg w-10 h-10 rounded-full bg-black
                  inline-flex justify-center items-center
                  text-gray-400
                  hover:text-designColor transition
                "
              >
                <FaGlobe />
              </a>
            )}
          </div>
        </div>

        {des && (
          <p className="text-sm tracking-wide text-gray-400">{des}</p>
        )}
      </div>
    </div>
  );
};

export default ProjectsCard;
